export const NAVBAR_ACTIVE = "NAVBAR_ACTIVE";
export const MENU_API = "MENU_API";
export const FOOTER = "FOOTER";
export const SET_LANGUAGE = "SET_LANGUAGE";